// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brandReviews_0E1j2{align-items:center;display:flex}.brandReviews_0E1j2 .v-btn__content{grid-gap:.6rem;gap:.6rem;padding:.8rem 0;width:auto}.brandReviews_0E1j2.brandReviews_0E1j2 .star-rating{grid-gap:.2rem;gap:.2rem}.brandReviews_0E1j2.brandReviews_0E1j2 .star-rating.is_boutique{--stroke-color:var(--cp-black)}.reviewRating_D6bNj{font-size:2rem;font-weight:500;line-height:2rem}.reviewCount_uJLb0{font-size:1.6rem;line-height:2rem;-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandReviews": "brandReviews_0E1j2",
	"reviewRating": "reviewRating_D6bNj",
	"reviewCount": "reviewCount_uJLb0"
};
module.exports = ___CSS_LOADER_EXPORT___;
